export default function getBodyTextStyle(style: BodyTextStyles) {
  switch (style) {
    case "paragraph_style":
      return "font-body tracking-[0.16px] text-midnight lg:text-lg [&_a]:underline text-base leading-normal font-normal lg:tracking-[0.16px]";
  }
}

export type BodyTextStyles = "paragraph_style";
